// extracted by mini-css-extract-plugin
export default {"tabsForModel":"TabsForModel_tabsForModel__+ehAw"};